import { render, staticRenderFns } from "./ResultImage.vue?vue&type=template&id=6100171c&scoped=true&"
import script from "./ResultImage.vue?vue&type=script&lang=js&"
export * from "./ResultImage.vue?vue&type=script&lang=js&"
import style0 from "./ResultImage.vue?vue&type=style&index=0&id=6100171c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100171c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemIcon})
